<template>
    <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirRotinas" centered>
        <template #modal-header>
            <div class="col-10">
                <h4>Configuração de tradução!</h4>
            </div>
        </template>

        <div class="col-12">
            <div class="row">
                <div class="col-6 mt-3">
                    <h6>Elemento:</h6>
                    <input class="form-control" v-model="palavra_frase" type="text" name="" id="">
                </div>
                <div class="col-6 mt-3 ">
                    <h6>Tradução:</h6>
                    <input class="form-control" v-model="traducao" type="text" name="" id="">
                </div>
            </div>
        </div>

        <template #modal-footer>
            <div class="w-100">
                <div class="row center" style="justify-content: center; ">
                    <div class="row center" style="justify-content: center; ">
                        <b-button class="mr-2" variant="danger" size="lg" @click="$emit('closeModal')">
                            Fechar
                        </b-button>
                        <b-button size="lg" variant="success" @click="salvarAgendamento">
                            Salvar
                        </b-button>
                    </div>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            exibirRotinas: true,
            palavra_frase: '',
            traducao: '',
            acaoGlobal: ''
        }
    },

    props: {
        palavra: {}
    },

    computed: {

    },

    methods: {
        salvarAgendamento() {
            const data = {
                acao_global: this.acaoGlobal,
                palavra_frase: this.palavra_frase.toUpperCase(),
                traducao: this.traducao.toUpperCase(),
                palavra: this.palavra
            }

            this.$store.dispatch('painel/acaoDicionario', { data: data }).then(response => {
                this.$emit('closeModal')
                this.$store.dispatch('painel/getPalavras')
                this.$swal.fire({
                    title: 'Sucesso!',
                    text: 'Agendamento salvo com sucesso!',
                    icon: 'success',
                    timer: 1000
                })
            }).catch(() => {
                this.$swal.fire({
                    title: 'Oops!',
                    text: 'Palavra já cadastrada!',
                    icon: 'warning',
                    timer: 2500
                })
            })
        },
    },
 
    created() {
        this.$store.dispatch('painel/getRotinas')
        this.$store.dispatch('painel/getEmpresas')
        // console.log(Object.entries(this.palavra).lenght === 0)

        if (this.palavra == '') {
            this.acaoGlobal = 'salvar'
        } else {
            console.log(this.palavra)
            this.palavra_frase = this.palavra.name
            this.traducao = this.palavra.lang_system[0].translate
            this.acaoGlobal = 'editar'
        }
    }
}
</script>